module.exports = __webpack_public_path__ + "img/landing21.f0e48545.jpg";